import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { SlimScrollModule } from 'ng2-slimscroll';
import { PrimecalendarRoutingModule } from './primecalendar-routing.module';
import { PrimeCalendarComponent } from './prime-calendar/prime-calendar.component';
import { BookingEntryComponent } from './booking-entry/booking-entry.component';
import { GuestBookingComponent } from './guest-booking/guest-booking.component';
import {SharedModule} from './../shared/shared.module';
@NgModule({
  imports: [
    CommonModule,
    PrimecalendarRoutingModule,
    SharedModule
  ],
  declarations: [PrimeCalendarComponent, BookingEntryComponent, GuestBookingComponent]
})
export class PrimecalendarModule { }



// WEBPACK FOOTER //
// ./src/app/primecalendar/primecalendar.module.ts